import React from "react";
import { ThumbsUpIcon, ThumbsDownIcon } from 'lucide-react';
import { Flex, IconButton } from "@commonsku/design-system";
import type { MessageFeedback } from "../../types/skubot";

export interface MessageFeedbackActionsProps {
  feedback?: MessageFeedback | null;
  onPositive: () => void;
  onNegative: () => void;
}

export function MessageFeedbackActions(props: MessageFeedbackActionsProps) {
  const { feedback, onPositive, onNegative } = props;
  const isPositive = feedback === "positive";
  const isNegative = feedback === "negative";

  return (
    <Flex gap="4px" mt="4px" align="center">
      <IconButton
        variant="ghost"
        size="sm"
        label="Thumbs up"
        onClick={onPositive}
        aria-pressed={isPositive}
        bgColor={isPositive ? "green.50" : "transparent"}
        color={isPositive ? "green.700" : "gray.950"}
        _hover={{
          bgColor: isPositive ? "green.50" : "gray.100",
          color: isPositive ? "green.700" : "gray.950",
        }}
      >
        <ThumbsUpIcon size="18px" />
      </IconButton>
      <IconButton
        variant="ghost"
        size="sm"
        label="Thumbs down"
        onClick={onNegative}
        aria-pressed={isNegative}
        bgColor={isNegative ? "red.50" : "transparent"}
        color={isNegative ? "red.700" : "gray.950"}
        _hover={{
          bgColor: isNegative ? "red.50" : "gray.100",
          color: isNegative ? "red.700" : "gray.950",
        }}
      >
        <ThumbsDownIcon size="18px" />
      </IconButton>
    </Flex>
  );
}
